// Determine environment
const isDevelopment = process.env.NODE_ENV === 'development';
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

// API URL configuration
const getApiUrl = () => {
  // Use environment variable if available
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Auto-detect based on current domain
  if (isLocalhost) {
    return 'http://localhost/cportal/backend/api';
  } else {
    // Production
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    return `${protocol}//${hostname}/backend/api`;
  }
};

const config = {
  API_URL: getApiUrl(),
  APP_NAME: process.env.REACT_APP_NAME || 'Cportal',
  APP_VERSION: process.env.REACT_APP_VERSION || '1.0.0',
  TOKEN_KEY: 'cportal_auth_token',
  USER_KEY: 'cportal_user_data',
  IS_DEVELOPMENT: isDevelopment,
  IS_LOCALHOST: isLocalhost,
};

// Log configuration in development
if (isDevelopment) {
  console.log('App Configuration:', {
    API_URL: config.API_URL,
    Environment: isDevelopment ? 'Development' : 'Production',
    IsLocalhost: isLocalhost
  });
}

export default config;
